import { render, staticRenderFns } from "./UserCombo.vue?vue&type=template&id=72bfffdd"
import script from "./UserCombo.vue?vue&type=script&lang=js"
export * from "./UserCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports